import { usePurchaseDeliveryApi } from "../api/PurchaseDeliveryApiClient";
import { PurchaseDeliveryFrontendService } from "../services/PurchaseDeliveryFrontendService";

export const usePurchaseDeliveryService = (): PurchaseDeliveryFrontendService =>
  new PurchaseDeliveryFrontendService(usePurchaseDeliveryApi());
